import TgaPlatform from "@tga-sdk/platform-sdk";

export default async function initTgaPlatformSDK() {
  if (!window.tgaPlatformSDK) {
    const env = process.env.SDP_ENV;

    window.tgaPlatformSDK = await TgaPlatform.init({
      env,
      afterInit(appId) {
        window.dataKule.push("config", env, appId);

        gtag("event", "channel", {
          channel: appId
        });
      }
    });

    // await window.tgaPlatformSDK.ad.initPageAd();
  }

  return window.tgaPlatformSDK;
}



// WEBPACK FOOTER //
// ./src/config/tgaPlatformSDK.js